import React from 'react';

import { Link } from 'gatsby';

import { styled } from '@mui/material';

import { extractTextMarking } from '@mewa/ui';

import t from '../../../../libs/translate';

type AuthorReferenceData = {
  name: string;
  authorLink?: string;
  translations: {
    author_box_by: string;
  };
};

export const AuthorReference = ({
  authorLink,
  name,
  translations,
}: AuthorReferenceData) => {
  const nameString = t(translations, 'author_box_by', {
    author_name: '[' + name + ']',
  });

  const nameLink = extractTextMarking(nameString);

  return (
    <Name>
      {nameLink.beforeMarking}{' '}
      {authorLink ? (
        <Link to={authorLink}>{nameLink.marking}</Link>
      ) : (
        <strong>{nameLink.marking}</strong>
      )}
      {nameLink.afterMarking ? ' ' + nameLink.afterMarking : ''}
    </Name>
  );
};

const Name = styled('span')(({ theme }) => ({
  ...theme.typography.body,

  a: {
    fontWeight: '500',
    textDecoration: 'underline',
    color: 'var(--color-black)',

    '&:hover': {
      color: 'var(--color-light-red)',
    },
  },

  strong: {
    fontWeight: '500',
  },
}));
